// src/pages/AdminLogin/AdminLogin.jsx
import React, { useState, useContext } from "react";
import axios from "axios";
import "./AdminLogin.css";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../apiConfig";

function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthState } = useContext(AuthContext);
  const navigate = useNavigate();
  const url = `${API_BASE_URL}`;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${url}/admin/login`,
        { username, password },
        { withCredentials: true }
      );
      setAuthState({ isAuthenticated: true, role: "admin" });
      navigate("/");
    } catch (error) {
      alert("Login failed");
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <h1 className="admin-login-title">Admin Login</h1>
        <form className="admin-login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <button className="submit-btn" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;